/**
 * A module of methods that you want to include in all stores.
 * This module is consumed by `createStore`.
 */
"use strict";

module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/reflux/~/reflux-core/lib/StoreMethods.js
 ** module id = 350
 ** module chunks = 0
 **/